module.exports = __webpack_public_path__ + "static/media/FamilyWellness_Web.198a0bc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Commercial/FamilyWellness_Web.jpg
// module id = 125
// module chunks = 0